// extracted by mini-css-extract-plugin
export default {"root":"ChartCard_root__+L7Ku","noborder":"ChartCard_noborder__zp-QN","title":"ChartCard_title__B80TH","content":"ChartCard_content__xZeQd"};